/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object, arrayOf } from 'prop-types';
import { useUIDSeed } from 'react-uid';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import mbpLogger from '@module-logger/mbp';
import useStyles from 'isomorphic-style-loader/useStyles';
import style from './FourUpVariantB.module.css';
import MessageStandard from '../../../../SubComponents/Message/MessageStandard';
import universalHandleClick from '../../../../UniversalHandleClick';
import normalizeAltCopy from '../../../../../../../helpers/normalizeAltCopy';

const FourUpVariantB = ({
    data, gaConstants, salesforceResponse,
}) => {
    useStyles(style);
    const isMobile = useMediaQuery('(max-width: 600px)');
    const seed = useUIDSeed();
    const ctaStyle = data?.cta_style?.presentation_variant;
    const defaultParams = 'auto=webp';

    if (data?.tile?.length) {
        const handleClick = universalHandleClick(salesforceResponse);
        return (
            <div className={style.container} data-testid="fourUpVariantB">
                {
                    data.tile.map(({
                        image_desktop = {}, image_mobile,  cta = {}, message = {}, styled_button,
                    }) => (
                        <div
                            key={seed(image_desktop)}
                            className={`${style.imageWrapper} ${!cta?.link?.href && !cta?.link?.title ? style.disableClick : ''}`}
                            role="presentation"
                            onClick={() => handleClick(cta, gaConstants)}
                            data-ga-category={cta?.tracking_event_category || gaConstants?.tracking_event_category}
                            data-ga-action={cta?.tracking_event_action || gaConstants?.tracking_event_action}
                            data-ga-label={cta?.tracking_event_label || gaConstants?.tracking_event_label}
                            data-banner-item-name={cta?.tracking_event_label || gaConstants?.tracking_event_label}
                            data-banner-type={cta?.tracking_event_action || gaConstants?.tracking_event_action}
                            data-banner-group={cta?.tracking_event_category || gaConstants?.tracking_event_category}
                            data-click-id="FourUpVariantB"
                            data-click-text="FourUpVariantB"
                        >
                            <img className={style.image} src={isMobile ? `${(image_mobile?.url || image_desktop?.url)}?${defaultParams}` : `${image_desktop?.url}?${defaultParams}`} alt={normalizeAltCopy(image_desktop.description || image_desktop.title || 'product image')} />
                            <div className={style.messageBlock}>
                                <MessageStandard
                                    data={{
                                        content: message.content,
                                        heading: message.heading,
                                        sub_heading: message.sub_heading,
                                        message_position: {},
                                        styled_button,
                                        cta: {
                                            link: cta.link,
                                            theme: cta.theme,
                                            presentation: cta?.presentation || ctaStyle,
                                            tracking_event_category: gaConstants.tracking_event_category,
                                            tracking_event_action: gaConstants.tracking_event_action,
                                            tracking_event_label: cta.tracking_event_label,
                                        },
                                        has_background: false,
                                    }}
                                />
                            </div>
                        </div>
                    ),
                    )
                }
            </div>
        );
    }

    return mbpLogger.logError({
        appName: process.env.npm_package_name,
        component: 'Tiles/Four/FourUpVariantB/FourUpVariantB.js',
        message: 'No data available to render component',
    });
};

FourUpVariantB.propTypes = {
    data: arrayOf.isRequired,
    gaConstants: object.isRequired,
    salesforceResponse: object,
};
FourUpVariantB.defaultProps = {
    salesforceResponse: {},
};

export default FourUpVariantB;
